import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BACKEND_URL}/api`, headers: { 'Content-Type': 'application/json' } });

// Dashboard
export const fetchDashboard = () => api.get('/dashboard').then(r => r.data);

// Properties
export const fetchProperties = (status) => {
  const params = status ? { status } : {};
  return api.get('/properties', { params }).then(r => r.data);
};
export const fetchProperty = (id) => api.get(`/properties/${id}`).then(r => r.data);
export const createProperty = (data) => api.post('/properties', data).then(r => r.data);
export const updateProperty = (id, data) => api.put(`/properties/${id}`, data).then(r => r.data);
export const deleteProperty = (id) => api.delete(`/properties/${id}`).then(r => r.data);
export const markPropertyDeeded = (id, data) => api.put(`/properties/${id}/escriturar`, data || {}).then(r => r.data);
export const markPropertyReleased = (id, data) => api.put(`/properties/${id}/liberar`, data || {}).then(r => r.data);
export const revertPropertyRelease = (id) => api.put(`/properties/${id}/revertir-liberacion`).then(r => r.data);

// Property Payments
export const fetchPropertyPayments = (propertyId, status) => {
  const params = {};
  if (propertyId) params.property_id = propertyId;
  if (status) params.status = status;
  return api.get('/property-payments', { params }).then(r => r.data);
};
export const createPropertyPayment = (data) => api.post('/property-payments', data).then(r => r.data);
export const updatePropertyPayment = (id, data) => api.put(`/property-payments/${id}`, data).then(r => r.data);
export const markPaymentReceived = (id, data) => api.put(`/property-payments/${id}/receive`, data || {}).then(r => r.data);
export const revertPaymentToProjected = (id) => api.put(`/property-payments/${id}/clear`).then(r => r.data);
export const deletePropertyPayment = (id) => api.delete(`/property-payments/${id}`).then(r => r.data);
export const sendPaymentReminder = (id) => api.put(`/property-payments/${id}/remind`).then(r => r.data);
export const sendNotification = (data) => api.post('/notifications/send', data).then(r => r.data);
export const fetchNotificationHistory = (paymentId) => api.get(`/notifications/history/${paymentId}`).then(r => r.data);
export const fetchNotificationPreview = (channel, paymentId) => api.get('/notifications/preview', { params: { channel, payment_id: paymentId } }).then(r => r.data);
export const generateAIMessage = (data) => api.post('/notifications/ai-generate', data).then(r => r.data);

// Reminder Queue
export const fetchReminderQueue = (params) => api.get('/reminders/queue', { params }).then(r => r.data);
export const fetchQueueSummary = () => api.get('/reminders/queue/summary').then(r => r.data);
export const generateReminders = () => api.post('/reminders/generate').then(r => r.data);
export const approveQueueItem = (id) => api.put(`/reminders/queue/${id}/approve`).then(r => r.data);
export const sendQueueItem = (id) => api.put(`/reminders/queue/${id}/send`).then(r => r.data);
export const discardQueueItem = (id) => api.put(`/reminders/queue/${id}/discard`).then(r => r.data);
export const editQueueItem = (id, data) => api.put(`/reminders/queue/${id}/edit`, data).then(r => r.data);
export const fetchReminderRules = () => api.get('/reminders/rules').then(r => r.data);
export const updateReminderRule = (id, data) => api.put(`/reminders/rules/${id}`, data).then(r => r.data);
export const fetchPaymentScoring = () => api.get('/scoring/payments').then(r => r.data);
export const fetchNotificationConfig = () => api.get('/config/notifications').then(r => r.data);
export const updateNotificationConfig = (data) => api.put('/config/notifications', data).then(r => r.data);

// Monthly Expenses
export const fetchMonthlyExpenses = (year, month) => {
  const params = {};
  if (year) params.year = year;
  if (month) params.month = month;
  return api.get('/monthly-expenses', { params }).then(r => r.data);
};
export const createMonthlyExpense = (data) => api.post('/monthly-expenses', data).then(r => r.data);
export const updateMonthlyExpense = (id, data) => api.put(`/monthly-expenses/${id}`, data).then(r => r.data);
export const deleteMonthlyExpense = (id) => api.delete(`/monthly-expenses/${id}`).then(r => r.data);

// Main Credit
export const fetchMainCredit = () => api.get('/main-credit').then(r => r.data);
export const updateMainCredit = (data) => api.put('/main-credit', data).then(r => r.data);

// Personal Loans
export const fetchPersonalLoans = () => api.get('/personal-loans').then(r => r.data);
export const createPersonalLoan = (data) => api.post('/personal-loans', data).then(r => r.data);
export const updatePersonalLoan = (id, data) => api.put(`/personal-loans/${id}`, data).then(r => r.data);
export const deletePersonalLoan = (id) => api.delete(`/personal-loans/${id}`).then(r => r.data);

// Flujo de Caja
export const fetchFlujoCaja = () =>
  api.get('/flujo-caja').then(r => r.data);
export const fetchFlujoConfig = () => api.get('/flujo-caja/config').then(r => r.data);
export const updateFlujoConfig = (data) => api.put('/flujo-caja/config', data).then(r => r.data);
export const fetchCajaInicial = () => api.get('/flujo-caja/caja-inicial').then(r => r.data);
export const updateCajaInicial = (saldo) => api.put('/flujo-caja/caja-inicial', { saldo_inicial: saldo }).then(r => r.data);

// Project Config
export const fetchProjectConfig = () => api.get('/config').then(r => r.data);
export const updateProjectConfig = (data) => api.put('/config', data).then(r => r.data);

// Work Catalog
export const fetchWorkCatalog = (category, activeOnly = true, catalogId = 'default') => {
  const params = { active_only: activeOnly, catalog_id: catalogId };
  if (category) params.category = category;
  return api.get('/work-catalog', { params }).then(r => r.data);
};
export const fetchWorkCategories = () => api.get('/work-catalog/categories').then(r => r.data);
export const createWorkCatalogItem = (data) => api.post('/work-catalog', data).then(r => r.data);
export const updateWorkCatalogItem = (id, data) => api.put(`/work-catalog/${id}`, data).then(r => r.data);
export const renameWorkCategory = (oldName, newName) => api.put(`/work-catalog/rename-category?old_name=${encodeURIComponent(oldName)}&new_name=${encodeURIComponent(newName)}`).then(r => r.data);
export const reorderWorkCategory = (categoryName, order) => api.put(`/work-catalog/reorder-category?category_name=${encodeURIComponent(categoryName)}&category_order=${order}`).then(r => r.data);
export const deleteWorkCatalogItem = (id) => api.delete(`/work-catalog/${id}`).then(r => r.data);
export const setCategoryCosts = (data) => api.put('/work-catalog/costs/category', data).then(r => r.data);
export const setGlobalCosts = (data) => api.put('/work-catalog/costs/global', data).then(r => r.data);
export const fetchCostsSummary = () => api.get('/work-catalog/costs/summary').then(r => r.data);
export const fetchCostProjection = () => api.get('/work-catalog/cost-projection').then(r => r.data);
export const fetchCostProjectionMonth = (mes) => api.get('/work-catalog/cost-projection').then(r => {
  const proj = r.data.monthly_projection || {};
  return proj[mes] || { materials: 0, labor: 0, properties: [] };
});
export const exportWorkCatalog = () => api.get('/work-catalog/export', { responseType: 'blob' }).then(r => {
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'catalogo_obra.csv';
  a.click();
  window.URL.revokeObjectURL(url);
});
export const importWorkCatalogPreview = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/work-catalog/import/preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};
export const importWorkCatalogConfirm = (items) => api.post('/work-catalog/import/confirm', { items }).then(r => r.data);

// Property Work Plan (includes both projected and actual)
export const fetchWorkPlan = (propertyId) => api.get('/property-work-plan', { params: { property_id: propertyId } }).then(r => r.data);
export const fetchWorkPlanSummary = (propertyId) => api.get(`/property-work-plan/summary/${propertyId}`).then(r => r.data);
// Work Catalogs (multiple)
export const fetchWorkCatalogs = () => api.get('/work-catalogs').then(r => r.data);
export const createWorkCatalog_v2 = (data) => api.post('/work-catalogs', data).then(r => r.data);
export const updateWorkCatalog_v2 = (id, data) => api.put(`/work-catalogs/${id}`, data).then(r => r.data);
export const cloneWorkCatalog = (id, data) => api.post(`/work-catalogs/${id}/clone`, data).then(r => r.data);

// Work Plan
export const inheritWorkPlan = (propertyId, catalogId = 'default') => api.post(`/property-work-plan/inherit/${propertyId}?catalog_id=${catalogId}`).then(r => r.data);
export const addPlanItem = (propertyId, data) => api.post(`/property-work-plan/add-item/${propertyId}`, data).then(r => r.data);
export const deletePlanItem = (id) => api.delete(`/property-work-plan/${id}`).then(r => r.data);
export const createWorkPlanItem = (data) => api.post('/property-work-plan', data).then(r => r.data);
export const updateWorkPlanItem = (id, data) => api.put(`/property-work-plan/${id}`, data).then(r => r.data);
export const deleteWorkPlanItem = (id) => api.delete(`/property-work-plan/${id}`).then(r => r.data);
export const setTrackingMode = (propertyId, mode) => api.put(`/property-work-plan/tracking-mode/${propertyId}?mode=${mode}`).then(r => r.data);

// Payment Abonos
export const fetchPaymentAbonos = (paymentId) => api.get(`/payment-abonos/${paymentId}`).then(r => r.data);
export const createPaymentAbono = (data) => api.post('/payment-abonos', data).then(r => r.data);
export const updatePaymentAbono = (id, data) => api.put(`/payment-abonos/${id}`, data).then(r => r.data);
export const deletePaymentAbono = (id) => api.delete(`/payment-abonos/${id}`).then(r => r.data);
export const fetchFacturacion = (params) => api.get('/facturacion', { params }).then(r => r.data);
export const uploadInvoiceXml = (abonoId, file) => {
  const fd = new FormData(); fd.append('file', file);
  return api.post(`/facturacion/upload-xml?abono_id=${abonoId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};
export const uploadInvoicePdf = (abonoId, file) => {
  const fd = new FormData(); fd.append('file', file);
  return api.post(`/facturacion/upload-pdf?abono_id=${abonoId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};
export const downloadInvoiceFile = (path) => {
  const token = localStorage.getItem('quru_token');
  const url = `${BACKEND_URL}/api/facturacion/file/${path}?token=${token}`;
  const a = document.createElement('a'); a.href = url; a.download = path.split('/').pop(); a.target = '_blank'; a.click();
};

// Collection Alerts
export const fetchCollectionAlerts = () => api.get('/collection-alerts').then(r => r.data);

// Auth
export const changePassword = (data) => api.put('/auth/change-password', data).then(r => r.data);
export const updateProfile = (data) => api.put('/auth/profile', data).then(r => r.data);
export const uploadProfileImage = (image) => api.put('/auth/profile-image', { image }).then(r => r.data);
export const deleteProfileImage = () => api.delete('/auth/profile-image').then(r => r.data);
export const mfaSetup = () => api.post('/auth/mfa/setup').then(r => r.data);
export const mfaActivate = (code) => api.post('/auth/mfa/activate', { code }).then(r => r.data);
export const mfaDisable = () => api.post('/auth/mfa/disable').then(r => r.data);
export const mfaShowQr = (code) => api.post('/auth/mfa/show-qr', { code }).then(r => r.data);
export const mfaAdminReset = (userId) => api.post(`/auth/mfa/admin-reset/${userId}`).then(r => r.data);
export const fetchPermissionMatrix = () => api.get('/permissions/matrix').then(r => r.data);
export const updateRolePermissions = (role, permissions) => api.put(`/permissions/role/${role}`, { permissions }).then(r => r.data);
export const fetchUserPermissions = (userId) => api.get(`/permissions/user/${userId}`).then(r => r.data);
export const updateUserOverrides = (userId, overrides) => api.put(`/permissions/user/${userId}`, { overrides }).then(r => r.data);
export const clearUserOverrides = (userId) => api.delete(`/permissions/user/${userId}`).then(r => r.data);
export const fetchAuditLog = (params) => api.get('/audit-log', { params }).then(r => r.data);
export const fetchAuditSummary = () => api.get('/audit-log/summary').then(r => r.data);
export const logLogout = () => api.post('/auth/logout').catch(() => {});

// Risk Analysis
export const fetchRiskAnalysis = () => api.get('/risk-analysis').then(r => r.data);
export const fetchMonthDetail = (mes, tipo) => api.get('/flujo-caja/detalle-mes', { params: { mes, tipo } }).then(r => r.data);
export const fetchLiberacionesDetalle = (mes) => api.get('/flujo-caja/liberaciones-detalle', { params: { mes } }).then(r => r.data);
export const fetchIngresosViviendasDetalle = (mes) => api.get('/flujo-caja/ingresos-viviendas-detalle', { params: { mes } }).then(r => r.data);
export const fetchMonthStatuses = () => api.get('/flujo-caja/month-status').then(r => r.data);
export const fetchCashRadar = () => api.get('/cash-radar').then(r => r.data);
export const setMonthStatus = (mes, status) => api.put(`/flujo-caja/month-status/${mes}?new_status=${status}`).then(r => r.data);

// Estimaciones
export const fetchEstimates = (status) => api.get('/estimaciones', { params: status ? { status } : {} }).then(r => r.data);
export const fetchEstimate = (id) => api.get(`/estimaciones/${id}`).then(r => r.data);
export const createEstimate = (data) => api.post('/estimaciones', data).then(r => r.data);
export const updateEstimate = (id, data) => api.put(`/estimaciones/${id}`, data).then(r => r.data);
export const deleteEstimate = (id) => api.delete(`/estimaciones/${id}`).then(r => r.data);
export const changeEstimateStatus = (id, status) => api.put(`/estimaciones/${id}/status?new_status=${status}`).then(r => r.data);
export const cloneEstimate = (id, data) => api.post(`/estimaciones/${id}/clone`, data).then(r => r.data);
export const exportEstimate = (id) => api.get(`/estimaciones/${id}/export`, { responseType: 'blob' }).then(r => {
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = `estimacion_${id}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
});
export const addAttendance = (estimateId, data) => api.post(`/estimaciones/${estimateId}/attendance`, data).then(r => r.data);
export const updateAttendance = (id, data) => api.put(`/estimaciones/attendance/${id}`, data).then(r => r.data);
export const deleteAttendance = (id) => api.delete(`/estimaciones/attendance/${id}`).then(r => r.data);
export const addDestajo = (estimateId, data) => api.post(`/estimaciones/${estimateId}/destajos`, data).then(r => r.data);
export const updateDestajo = (id, data) => api.put(`/estimaciones/destajos/${id}`, data).then(r => r.data);
export const deleteDestajo = (id) => api.delete(`/estimaciones/destajos/${id}`).then(r => r.data);

// Personal
export const fetchPersonnel = (activeOnly = true) => api.get('/personal', { params: { active_only: activeOnly } }).then(r => r.data);
export const createPerson = (data) => api.post('/personal', data).then(r => r.data);
export const updatePerson = (id, data) => api.put(`/personal/${id}`, data).then(r => r.data);
export const deactivatePerson = (id) => api.delete(`/personal/${id}`).then(r => r.data);

// Contratos Destajo
export const fetchContracts = (params) => api.get('/contratos-destajo', { params }).then(r => r.data);
export const fetchContract = (id) => api.get(`/contratos-destajo/${id}`).then(r => r.data);
export const createContract = (data) => api.post('/contratos-destajo', data).then(r => r.data);
export const updateContract = (id, data) => api.put(`/contratos-destajo/${id}`, data).then(r => r.data);

// Avance Semanal
export const fetchWeeklyProgressWeeks = () => api.get('/avance-semanal/weeks').then(r => r.data);
export const createProgressWeek = (data) => api.post('/avance-semanal/weeks', data).then(r => r.data);
export const updateProgressWeek = (id, data) => api.put(`/avance-semanal/weeks/${id}`, data).then(r => r.data);
export const changeWeekStatus = (weekId, status) => api.put(`/avance-semanal/weeks/${weekId}/status?new_status=${status}`).then(r => r.data);
export const fetchWeeklyProgress = (weekLabel) => api.get('/avance-semanal/week', { params: { week_label: weekLabel } }).then(r => r.data);
export const fetchPropertyWeeklyHistory = (propertyId) => api.get(`/avance-semanal/property/${propertyId}`).then(r => r.data);
export const createWeeklyProgress = (data) => api.post('/avance-semanal', data).then(r => r.data);
export const updateWeeklyProgress = (id, data) => api.put(`/avance-semanal/${id}`, data).then(r => r.data);
export const batchCreateWeeklyProgress = (entries) => api.post('/avance-semanal/batch', entries).then(r => r.data);
export const deleteProgressWeek = (weekId) => api.post(`/avance-semanal/delete-week/${weekId}`).then(r => r.data);
export const deletePropertyFromWeek = (weekLabel, propertyId) => api.delete(`/avance-semanal/week-property/${encodeURIComponent(weekLabel)}/${propertyId}`).then(r => r.data);
export const deleteProgressEntry = (id) => api.delete(`/avance-semanal/${id}`).then(r => r.data);
export const cloneWeekProgress = (data) => api.post('/avance-semanal/clone-week', data).then(r => r.data);
export const approveWeekProgress = (weekLabel) => api.post('/avance-semanal/approve-week', { week_label: weekLabel }).then(r => r.data);
export const migrateClosedWeeks = () => api.post('/avance-semanal/migrate-closed-to-verified').then(r => r.data);

export default api;
